

import { fileSystemStore } from '@/store';
import { computed } from 'vue';
import router from '@/router';

export default {
  setup() {
    return {
      ...useAppInitialize()
    };
  }
};

function useAppInitialize() {
  async function initialize() {
    await fileSystemStore.initialize();
    if (router.currentRoute.value.query.r) {
      // If provided, go to designated path
      // This will be set by the global router guard
      router.replace(router.currentRoute.value.query.r as string);
    } else {
      // By default go to main music page
      router.replace('/music');
    }
  }

  return {
    isInitialized: computed(() => !!fileSystemStore.getState().rootHandle),
    initialize
  };
}
